import Vue from "vue"
const VueMoment = require("vue-moment")

Vue.use(VueMoment)
